import moment from "moment";
import { fetchConToken, fetchConTokenFiles } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { types } from "../../types/types";
import { RECLAMOS_ESTADOS } from "../../utils/constants";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const setActiveBreadcrumbReclamos = (activeBreadcrumb) => ({
    type: types.setActiveBreadcrumbReclamo, payload: activeBreadcrumb
});

export const setRecepcionMenu = (menu) => ({
    type: types.recepcionReclamoSetMenu,
    payload: menu,
});

export const setDataAfiliado = (dataAfiliado) => ({
    type: types.reclamosSetDataAfiliado,
    payload: dataAfiliado
});

export const setDataExternos = (dataExternos) => ({
    type: types.reclamosSetDataExternos,
    payload: dataExternos
});

export const setDataEfector = (dataEfector) => ({
    type: types.reclamosSetDataEfector,
    payload: dataEfector
});

export const desSeleccionarAfiliado = () => ({
    type: types.reclamosAfiliadoLimpiarSeleccion,
});

export const desSeleccionarEfector = () => ({
    type: types.reclamosEfectorLimpiarSeleccion,
});

export const desSeleccionarExternos = () => ({
    type: types.reclamosExternosLimpiarSeleccion,
});

export const cleanReclamosTomados = () => {
    return { type: types.reclamosTomadosLimpiar };
  };

export const ingresoTipoReclamo = (tipoReclamo) => ({ type: types.reclamosSetTipoReclamo, payload: tipoReclamo });
export const ingregoTipoOrigen = (tipoOrigen) => ({ type: types.reclamosSetTipoOrigen, payload: tipoOrigen });
export const setActiveStepReclamos = (step) => ({ type: types.reclamosSetStep, payload: step });
export const reclamoTomar = (body) => ({ type: types.tomarReclamoIngresado, payload: body });

// Documentacion Reclamos
//export const insertDocumentacionReclamo = (docu) => ({ type: types.documentacionReclamosInsert, payload: docu });
//export const deleteDocumentacionReclamo = (docu) => ({ type: types.documentacionReclamosEliminar, payload: docu.idDocumentacionReclamo });

// Documentacion
export const cleanDocumentacionReclamos = () => ({ type: types.documentacionReclamosClean });
export const errorDocumentacionReclamos = () => ({ type: types.documentacionReclamosError });
export const getDocumentacionReclamos = (body) => ({ type: types.documentacionReclamosSucces, payload: body });
export const postDocumentacionReclamos = (body) => ({ type: types.documentacionReclamosInsert, payload: body });
export const deleteDocumentacionReclamos = (id) => ({ type: types.documentacionReclamosEliminar, payload: id });


// Documentacion Efector
export const cleanDocumentacionReclamosEfector = () => ({ type: types.documentacionReclamosEfectorClean });
export const errorDocumentacionReclamosEfector = () => ({ type: types.documentacionReclamosEfectorError });
export const getDocumentacionReclamosEfector = (body) => ({ type: types.documentacionReclamosEfectorSucces, payload: body });
export const postDocumentacionReclamosEfector = (body) => ({ type: types.documentacionReclamosEfectorInsert, payload: body });
export const deleteDocumentacionReclamosEfector = (id) => ({ type: types.documentacionReclamosEfectorEliminar, payload: id });


export const cleanReclamosEnviados = () => ({ type: types.cleanReclamosEnviados });


export const setEstadoSolicitudesReclamos = (estado) => {
    return {
        type: types.reclamosUpdateEstadoSolicitudes,
        payload: estado,
    };
};

export const setSolicitudReclamo = (solicitud) => {
    return {
        type: types.reclamosSetSolicitudSeleccionada,
        payload: solicitud,
    };
};

export const setEfectorReclamo = (idEfectorReclamo, descripcionEfectorReclamo) => {
    return {
        type: types.traerEfectorReclamo,
        payload: { idEfectorReclamo, descripcionEfectorReclamo }
    };
};

export const FetchAreasFisicas = () => async (dispatch) => {

    try {
        const response = await fetchConToken(`AreasFisicas`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.listaTipoReclamosSuccess,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Tipos de Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}


export const FetchTiposReclamos = () => async (dispatch) => {

    try {
        const response = await fetchConToken(`Reclamos/TiposReclamos`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.listaTipoReclamosSuccess,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Tipos de Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const FetchTiposOrigenes = () => async (dispatch) => {

    try {
        const response = await fetchConToken(`Reclamos/TipoOrigenes`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.listaTipoOrigenesSuccess,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Tipos de Origen.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const FetchCategoriasReclamos = () => async (dispatch) => {

    try {
        const response = await fetchConToken(`Reclamos/CategoriasReclamos`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.listaCategoriasReclamosSuccess,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar las categorias Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }
}



export const TraerTipoComentarios = () => async (dispatch) => {
    try {
        const response = await fetchConToken(`Reclamos/TraerTipoComentarios`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traertipoComentarioReclamos,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los tipos comentarios .", "Ha ocurrido un error. Intente Nuevamente")
    }

}



export const NuevoReclamo = (datos) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        

        const response = await fetchConToken(`Reclamos/Ingreso`, datos, "POST");
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta("Reclamo creado correctamente", 'success', 'Comando Exitoso'))
            dispatch({
                type: types.tomarReclamoIngresado,
                payload: body[0]
            })
            dispatch(enviarMailReclamo(body[0].id))
            dispatch(TraerReclamoPorId(body[0].id))
            dispatch(finishSpinner());

        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al crear un plazo.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const TraerReclamoPorId = (id) => async (dispatch) => {
    try {
        const response = await fetchConToken(`Reclamos/${id}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traerReclamosTodos,
                payload: body[0]
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar .", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const TraerReclamoPorIdAfiliado = (idAfiliado) => async (dispatch) => {

    try {
        const response = await fetchConToken(`Reclamos/TraerPorIdAfi/${idAfiliado}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerReclamoPorIdAfiliado,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar .", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const BuscarReclamoPorId = (id) => async (dispatch) => {

    try {
        const response = await fetchConToken(`Reclamos/${id}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traerReclamoPorIdAfiliado,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar .", "Ha ocurrido un error. Intente Nuevamente")
    }

}


export const BuscarAfiliadoPorDNI = (dni) => async (dispatch) => {
    try {
        const response = await fetchConToken(`Afiliados/traerPorDNI/${dni}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.reclamosSetDataAfiliado,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar .", "No se encuentra Afiliado. Intente Nuevamente")
    }

}

export const TraerTrackingReclamos = (idReclamo) => async (dispatch) => {

    try {
        const response = await fetchConToken(`Reclamos/TraerTracking/${idReclamo}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.trackingReclamos,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar .", "Ha ocurrido un error. Intente Nuevamente")
    }

}


export const TraerReclamos = (estado, area, subArea, fechaInicio, fechaFin) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/TraerReclamosTodos?estado=${+estado}&destino=${area}&subDestino=${subArea !== null ? subArea : 0}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traerReclamosTodos,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al traer los reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const TraerContadoresReclamos = (area) => async (dispatch) => {

    try {
        const response = await fetchConToken(`Reclamos/TraerContadores/${area}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.reclamosGetContadoresSolicitudesSuccess,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los contadores.", "Ha ocurrido un error. Intente Nuevamente")
    }

}


export const FetchDataAfiliado = (idAfiliado) => async (dispatch) => {

    try {
        const response = await fetchConToken(`Afiliados/traerPorIdAfiliado/${idAfiliado}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.reclamosSetDataAfiliado,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Tipos de Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const FetchComentarios = (idReclamo) => async (dispatch) => {

    try {
        const response = await fetchConToken(`Reclamos/TraerComentarios/${idReclamo}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.reclamosGetComentariosSolicitudesSuccess,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los comentarios de Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}


export const agregarComentario = (idReclamo, comentario, idTipoComentario) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        const data = {
            idreclamo: idReclamo,
            comentario: comentario,
            idTipoComentario: idTipoComentario
        }
        const response = await fetchConToken(`Reclamos/IngresarComentario`, data, "POST");
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta("Comentario creado correctamente", 'success', 'Comando Exitoso'));
            dispatch(FetchComentarios(idReclamo))
            dispatch(finishSpinner());

        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al crear comentario.", "Ha ocurrido un error. Intente nuevamente")
    }
};


export const updateDerivacionReclamo = (idReclamo, derivado, subDerivado, areasFisicasUsuario, fechaInicio, fechaFin, descDerivadoA, descSubDerivadoA) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        const data = {
            idReclamo: idReclamo,
            derivado: derivado,
            subDerivado: subDerivado !== null ? subDerivado : 0,
            derivadoAnt: descDerivadoA,
            subDerivadoAnt: descSubDerivadoA !== null ? descSubDerivadoA : ""


        }
        const response = await fetchConToken(`Reclamos/UpdateDerivacion`, data, "PUT");
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta("Derivado correctamente", 'success', 'Comando Exitoso'));
            dispatch(TraerReclamos(RECLAMOS_ESTADOS.PENDIENTE, areasFisicasUsuario.idArea, areasFisicasUsuario.idSubArea, fechaInicio, fechaFin))
            dispatch(finishSpinner());


        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al derivar.", "Ha ocurrido un error. Intente nuevamente")
    }
};


export const cambiarEstadoReclamo = (data, estadoSolicitudes, areasFisicasUsuario, fechaInicio, fechaFin) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        const response = await fetchConToken(`Reclamos/CambiarEstadoReclamo`, data, "PUT");
        const body = await response.json();
        if (response.ok) {
            dispatch(TraerReclamos(estadoSolicitudes, areasFisicasUsuario.idArea, areasFisicasUsuario.idSubArea, fechaInicio, fechaFin));
            dispatch(startAlerta("Cambio realizado correctamente", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());

        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al modificar.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const InsertarEfectorReclamo = (idReclamo, idEfectorReclamo, descripcionEfectorReclamo, area, subArea, fechaInicio, fechaFin) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        const data = {
            idReclamo: idReclamo,
            idEfectorReclamo: idEfectorReclamo
        }
        const response = await fetchConToken(`Reclamos/InsertarEfectorReclamo`, data, "POST");
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta("Ingresado correctamente", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
            dispatch(TraerReclamos(RECLAMOS_ESTADOS.PENDIENTE, area, subArea, fechaInicio, fechaFin))
            dispatch(setEfectorReclamo(idEfectorReclamo, descripcionEfectorReclamo))

        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al derivar.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const EliminarEfectorReclamo = (idReclamo, idEfectorReclamo, area, subArea, fechaInicio, fechaFin) => async (dispatch) => {

    try {
        dispatch(startSpinner());
        const data = {
            idReclamo: idReclamo,
            IdEfectorFacturacion: idEfectorReclamo
        }
        const response = await fetchConToken(`Reclamos/EliminarEfectorReclamo`, data, "DELETE");
        const body = await response.json();
        if (response.ok) {
            const dataNew = []
            dispatch(startAlerta("Eliminado correctamente", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
            dispatch(TraerReclamos(RECLAMOS_ESTADOS.PENDIENTE, area, subArea, fechaInicio, fechaFin))
            dispatch(setEfectorReclamo(dataNew))

        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al derivar.", "Ha ocurrido un error. Intente nuevamente")
    }
};


export const anularReclamo = (idReclamo, area, subArea, fechaInicio, fechaFin) => async (dispatch) => {

    try {
        dispatch(startSpinner());
        const data = {
            idReclamo: idReclamo
        }
        const response = await fetchConToken(`Reclamos/AnulacionReclamo`, data, "PUT");
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta("Reclamo anulado correctamente", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
            dispatch(TraerReclamos(RECLAMOS_ESTADOS.PENDIENTE, area, subArea, fechaInicio, fechaFin))

        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al anular.", "Ha ocurrido un error. Intente nuevamente")
    }
};


export const finalizarReclamo = (idReclamo, area, subArea, fechaInicio, fechaFin) => async (dispatch) => {

    try {
        dispatch(startSpinner());
        const data = {
            idReclamo: idReclamo
        }
        const response = await fetchConToken(`Reclamos/FinalizarReclamo`, data, "PUT");
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta("Reclamo finalizado correctamente", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
            dispatch(TraerReclamos(RECLAMOS_ESTADOS.PENDIENTE, area, subArea, fechaInicio, fechaFin))

        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al finalizar reclamo.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const BuscadorBandejaPorAfiliado = (dni, destino, subDestino, estado, fechaInicio, fechaFin) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/BuscadorPorAfiliado?dni=${+dni}&destino=${destino}&subDestino=${subDestino !== null ? subDestino : 0}&estado=${estado}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}`);
        const body = await response.json();
        let contador = []
        if (response.ok) {
            dispatch({
                type: types.traerReclamosTodos,
                payload: body
            })
            dispatch({
                type: types.reclamosGetContadoresSolicitudesSuccess,
                payload: contador
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const BuscadorBandejaPorIdReclamo = (idReclamo, destino, subDestino, estado, fechaInicio, fechaFin) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/BuscadorPorIdReclamo?idReclamo=${+idReclamo}&destino=${destino}&subDestino=${subDestino !== null ? subDestino : 0}&estado=${estado}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}`);
        const body = await response.json();
        let contador = []
        if (response.ok) {
            dispatch({
                type: types.traerReclamosTodos,
                payload: body
            })
            dispatch({
                type: types.reclamosGetContadoresSolicitudesSuccess,
                payload: contador
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

//DOCUMENTACION

export const getDocumentacionComprobanteReclamo = (idReclamo) =>
    async (dispatch) => {
        dispatch(startSpinner());
        try {
            const response = await fetchConToken(`ReclamosDocumentacion/${idReclamo}`)
            const body = await response.json();
            if (response.ok) {
                dispatch(getDocumentacionReclamos(body));
                dispatch(finishSpinner());
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            dispatch(errorDocumentacionReclamos());
            handleErrorApi(dispatch, error, "Error al traer documentacion", "Ha ocurrido un error. Intente nuevamente");
        }
    }

export const setDocumentacionReclamo = (formData, idTipoDoc, idReclamo) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        try {
            const response = await fetchConTokenFiles(
                `ReclamosDocumentacion/${idTipoDoc}/${idReclamo}`,
                formData,
                "POST",
                dispatch
            );
            const body = await response.json();
            if (response.ok) {
                dispatch(postDocumentacionReclamos(body));
                dispatch(
                    startAlerta(
                        "Datos Guardados Exitosamente",
                        "success",
                        "Comando Exitoso"
                    )
                );
                dispatch(finishSpinner());
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al guardar el documento.",
                "Ha ocurrido un error. Intente nuevamente."
            );
        }
    };
};

export const deleteDocumentoReclamos = (idDocumentacionReclamo) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        try {
            const response = await fetchConToken(
                `ReclamosDocumentacion/${idDocumentacionReclamo}`,
                {},
                "DELETE",
            );
            const body = await response.json();
            if (response.ok) {
                dispatch(deleteDocumentacionReclamos(idDocumentacionReclamo));
                dispatch(finishSpinner());
                dispatch(
                    startAlerta(
                        "Documento Eliminado Exitosamente",
                        "success",
                        "Comando Exitoso"
                    )
                );
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al eliminar el documento.",
                "Ha ocurrido un error. Intente nuevamente."
            );
        }
    };
};

export const enviarMailReclamo = (idReclamo) => {
    return async (dispatch) => {
        try {
            dispatch(startSpinner());
            const response = await fetchConToken(`Reclamos/generarMail/${idReclamo}`);
            const body = await response.json();
            if (response.status === 200) {
                dispatch(
                    startAlerta(
                        `Mail enviado exitosamente`,
                        'success',
                        'Comando Exitoso',
                    ),
                );
            } else {
                throw body;
            }
            dispatch(finishSpinner());
        } catch (err) {
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                err,
                'Ocurrio un error en el envío',
                'Ha ocurrido un error. Intente nuevamente',
            );
        }
    };
};

export const FetchOrigenErrorReclamos = () => async (dispatch) => {
    try {
        const response = await fetchConToken(`Reclamos/OrigenErrorReclamo`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.listaOrigenErrorReclamoSuccess,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar el origenes error reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const InsertarOrigenErorrReclamo = (data) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        const response = await fetchConToken(`Reclamos/OrigenErrorReclamo`, data, "PUT");
        const body = await response.json();
        if (response.ok) {
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al insertar el origen.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const TraerReclamosEnviadosAfiliado = (estado, fechaInicio, fechaFin, idAfiliado, destino, subDestino) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/TraerReclamosEnviadosAfiliado?estado=${+estado}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}&idAfiliado=${idAfiliado !== null ? idAfiliado : 0}&destino=${destino !==null ? destino : 0}&subDestino=${subDestino !==null ? subDestino : 0}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerReclamosEnviados,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}


export const generarExcelReclamosEnviadosAfiliados = (estado, fechaInicio, fechaFin, idAfiliado, destino, subDestino) => async (dispatch) => {

    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    let idAfiMod = idAfiliado !== null ? idAfiliado : 0
    let idDestino = destino !== null ? destino : 0
    let idSubDestino = subDestino !==null ? subDestino : 0
    try {
        const response = await fetchConToken(`Reclamos/GenerarExcelReclamosEnviadosAfiliados/${estado},${fechaInicioMod},${fechaFinMod},${idAfiMod},${idDestino},${idSubDestino}`);

        const body = await response.blob();
        if (response.ok) {
            dispatch(finishSpinner());
            let url = window.URL.createObjectURL(body);
            let a = document.createElement('a');
            a.href = url;
            a.download = `ReclamosEnviadosAfiliados.xlsx`;
            a.click();
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al traer el excel",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }

}


//DOCUMENTACION RECLAMOS

export const getDocumentacionComprobanteReclamoEfector = (idReclamo) =>
    async (dispatch) => {
        dispatch(startSpinner());
        try {
            const response = await fetchConToken(`ReclamosDocumentacionEfector/${idReclamo}`)
            const body = await response.json();
            if (response.ok) {
                dispatch(getDocumentacionReclamosEfector(body));
                dispatch(finishSpinner());
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            dispatch(errorDocumentacionReclamosEfector());
            handleErrorApi(dispatch, error, "Error al traer documentacion", "Ha ocurrido un error. Intente nuevamente");
        }
    }

export const setDocumentacionReclamoEfector = (formData, idTipoDoc, idReclamo) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        try {
            const response = await fetchConTokenFiles(
                `ReclamosDocumentacionEfector/${idTipoDoc}/${idReclamo}`,
                formData,
                "POST",
                dispatch
            );
            const body = await response.json();
            if (response.ok) {
                dispatch(postDocumentacionReclamosEfector(body));
                dispatch(
                    startAlerta(
                        "Datos Guardados Exitosamente",
                        "success",
                        "Comando Exitoso"
                    )
                );
                dispatch(finishSpinner());
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al guardar el documento.",
                "Ha ocurrido un error. Intente nuevamente."
            );
        }
    };
};

export const deleteDocumentoReclamosEfector = (idDocumentacionReclamo) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        try {
            const response = await fetchConToken(
                `ReclamosDocumentacionEfector/${idDocumentacionReclamo}`,
                {},
                "DELETE",
            );
            const body = await response.json();
            if (response.ok) {
                dispatch(deleteDocumentacionReclamosEfector(idDocumentacionReclamo));
                dispatch(finishSpinner());
                dispatch(
                    startAlerta(
                        "Documento Eliminado Exitosamente",
                        "success",
                        "Comando Exitoso"
                    )
                );
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al eliminar el documento.",
                "Ha ocurrido un error. Intente nuevamente."
            );
        }
    };
};

export const TraerTrackingReclamosEfector = (idReclamo) => async (dispatch) => {

    try {
        const response = await fetchConToken(`Reclamos/TraerTrackingEfector/${idReclamo}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.trackingReclamos,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar .", "Ha ocurrido un error. Intente Nuevamente")
    }

}


export const FetchEfectorFacturacion = (idEfectorFacturacion) => async (dispatch) => {

    try {
        const response = await fetchConToken(`EfectorFacturacion/${idEfectorFacturacion}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.reclamosSetDataEfector,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los datos del efector.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const CambiarCategoriaReclamo = (data, estadoSolicitudes, areasFisicasUsuario, fechaInicio, fechaFin) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        const response = await fetchConToken(`Reclamos/CambiarCategoriaReclamo`, data, "POST");
        const body = await response.json();
        if (response.ok) {
            dispatch(TraerReclamos(estadoSolicitudes, areasFisicasUsuario.idArea, areasFisicasUsuario.idSubArea, fechaInicio, fechaFin));
            dispatch(startAlerta("Cambio realizado correctamente", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());

        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al modificar.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const imprimirPDFReclamo = (idSolicitud) => {
    return async (dispatch) => {
      try {
        dispatch(startSpinner());
        const response = await fetchConToken(
            `Reclamos/generarPDFReclamo/${idSolicitud}`,
          );
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/pdf") !== -1) {
          const body = await response.blob();
          if (response.ok) {
            dispatch(finishSpinner());
            window.open(URL.createObjectURL(body));
          } else {
            throw body;
          }
        }
        dispatch(finishSpinner());
      } catch (err) {
        console.log(err);
        dispatch(finishSpinner());
        dispatch(
          startAlerta(
            "Ocurrio un error en la generación del PDF",
            "warning",
            `¡Error!`
          )
        );
      }
    };
  };

  export const enviarPDFSolicitudReclamo = (idSolicitud) => {
    return async (dispatch) => {
      try {
        dispatch(startSpinner());
        const response = await fetchConToken(
            `Reclamos/enviarPDFSolicitud/${idSolicitud}`,
          );
        const body = await response.json();
        if (response.status === 200) {
          dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
        } else {
          throw body;
        }
        dispatch(finishSpinner());
      } catch (err) {
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          err,
          "Ocurrio un error en el envío del PDF",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    };
  };
  
  export const enviarMailAvisoEstadoReclamo = (idReclamo) => {
    return async (dispatch) => {
        try {
            dispatch(startSpinner());
            const response = await fetchConToken(`Reclamos/envioAvisoAfiliado/${idReclamo}`);
            const body = await response.json();
            if (response.status === 200) {
                dispatch(
                    startAlerta(
                        `Mail enviado exitosamente`,
                        'success',
                        'Comando Exitoso',
                    ),
                );
            } else {
                throw body;
            }
            dispatch(finishSpinner());
        } catch (err) {
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                err,
                'Ocurrio un error en el envío',
                'Ha ocurrido un error. Intente nuevamente',
            );
        }
    };
};
  

export const getReclamosTomadaos = () => {
    return async (dispatch) => {
      try {
        dispatch(startSpinner());
        const result = await fetchConToken(`ReclamosTomados/traerTomadas`);
        const body = await result.json();
        if (result.ok) {
          dispatch({
            type: types.reclamosTomadosSuccess,
            payload: body,
          });
        } else {
          throw body;
        }
        dispatch(finishSpinner());
      } catch (error) {
        dispatch(finishSpinner());
        dispatch({
          type: types.reclamosTomadosError,
        });
        handleErrorApi(
          dispatch,
          error,
          "Error al obtener los reclamos Tomados",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    };
  };

  export const getReclamosTomadosPorUsuario = () => {
    return async (dispatch) => {
      try {
        dispatch(startSpinner());
        const result = await fetchConToken(`ReclamosTomados/traerPorUsuario`);
        const body = await result.json();
        if (result.ok) {
          dispatch({
            type: types.reclamosTomadosUsuarioSuccess,
            payload: body,
          });
        } else {
          throw body;
        }
        dispatch(finishSpinner());
      } catch (error) {
        dispatch(finishSpinner());
        dispatch({
          type: types.reclamosTomadosUsuarioError,
        });
        handleErrorApi(
          dispatch,
          error,
          "Error al obtener los reclamos Tomados por Usuario",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    };
  };

  export const putLiberarReclamo = (id, userType, idReclamo) => {
    return async (dispatch) => {
      try {
        dispatch(startSpinner());
        debugger
        const data = {
            idTomado : id
        }
        const result = await fetchConToken(`ReclamosTomados`, data, "PUT");
        const body = await result.json();
        if (result.ok) {
          if (userType === "currentUser") {
            dispatch({
              type: types.reclamosTomadosUsuarioLiberar,
              payload: id,
            });
            dispatch({
              type: types.reclamosTomadosLiberarTomadoPorIdReclamo,
              payload: idReclamo,
            });
          }
          else if (userType === "allUsers")
            dispatch({
              type: types.reclamosTomadosLiberar,
              payload: id,
            });
        } else {
          throw body;
        }
        dispatch(finishSpinner());
      } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          error,
          "Error al liberar el reclamo",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    };
  };

  export const postTomarReclamo = (reclamo, setOpenModalAuditar) => {
    return async (dispatch, getState) => {
      try {
        dispatch(startSpinner());
        const data = {
            idReclamo : reclamo.id
        }
        const result = await fetchConToken(`ReclamosTomados`, data, "POST");
        debugger
        const body = await result.json();
        if (result.ok) {
          if (body.id !== 0) {
            dispatch({
              type: types.reclamosTomadosUsuarioAgregar,
              payload: body,
            });
            dispatch({
              type: types.reclamosMarcarTomado,
              payload: { reclamo, auth: getState().auth },
            });
            setOpenModalAuditar(true);
            dispatch(setSolicitudReclamo(reclamo));
          }
        } else {
          throw body;
        }
        dispatch(finishSpinner());
      } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          error,
          "Error al tomar el reclamo",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    };
  };






